"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports._FitssoCloudFunction = void 0;
// export const _FitssoCloudFunction =
//   'https://fitsso-729907915433.europe-west3.run.app/';
exports._FitssoCloudFunction = 'http://localhost:1234/';
